import { render, staticRenderFns } from "./TotalDeliveryChart.vue?vue&type=template&id=27c95bfd&scoped=true&"
import script from "./TotalDeliveryChart.vue?vue&type=script&lang=js&"
export * from "./TotalDeliveryChart.vue?vue&type=script&lang=js&"
import style0 from "./TotalDeliveryChart.vue?vue&type=style&index=0&id=27c95bfd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c95bfd",
  null
  
)

export default component.exports